export { default } from '../life/checkLifeAge';
